import type { DrawerComponentProps } from '../../types/drawer.types';
import Drawer from '../ui/drawer';
import Button from '../ui/button';

interface DrawerProps extends DrawerComponentProps {
    content: string
}

export default function NotificationDrawer({ onClose, content }: DrawerProps) {
  return (
    <Drawer placement="top" size="md" close={onClose}>
      <header className="flex items-center justify-between border-b border-border-main px-4 py-4">
        <h2 id="drawer-title" className="text-xl font-bold">
          알림
        </h2>
        <Button
          variant="ghost"
          isIcon={true}
          size="sm"
          onClick={onClose}
          aria-label="닫기"
        >
          닫기
        </Button>
      </header>

      <div className="flex-1 overflow-y-auto p-6">
        <p>{content}</p>
      </div>
      
    </Drawer>
  );
};